import api from "../utils/API";

// Base URL for your API
export const salesDatasService = {
  fetchList: async (payload) => {
    try {
      const response = await api.get("/admin/sales", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  previewSalesDatas: async (payload) => {
    try {
      const response = await api.post("/admin/sales/preview-upload", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  syncSalesDatas: async (payload) => {
    try {
      const response = await api.post("/admin/sales", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  deletePurchase: async (id) => {
    try {
      const response = await api.delete(`/admin/sales/${id}`);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
